import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { SwitchProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardSwitch = dynamic(() => import("./DashboardSwitchSsr").then((mod) => mod.DashboardSwitchSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardSwitch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => (
  <DynamicDashboardSwitch {...props} forwardedRef={ref} />
));

DashboardSwitch.displayName = "DashboardSwitch";
